// See: https://www.datocms.com/blog/offer-responsive-progressive-lqip-images-in-2020

/** Retina-friendly `sizes` for full-width heroes/backgrounds (HTML + Dato). */
export const FULL_BLEED_IMAGE_SIZES =
  "(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 1920px";

export const CONTENT_IMAGE_SIZES =
  "(max-width: 768px) 100vw, (max-width: 1024px) 90vw, 1200px";

export const responsiveImageFragment = `
  fragment responsiveImageFragment on ResponsiveImage {
    srcSet
    webpSrcSet
    sizes
    src
    width
    height
    aspectRatio
    alt
    title
    base64
  }
`;

export const metaTagsFragment = `
  fragment metaTagsFragment on Tag {
    attributes
    content
    tag
  }
`;

/** Solid brand color (BrandColorRecord). */
export const brandColorRecordFields = `
  ... on BrandColorRecord {
    id
    name
    color {
      hex
      cssRgb
    }
  }
`;

/** Gradient block; firstColor / secondColor are BrandColorRecord links. */
export const colorGradientRecordFields = `
  ... on ColorGradientRecord {
    id
    direction
    proportion
    mainColorDistribution
    firstColor {
      id
      name
      color {
        hex
        cssRgb
      }
    }
    secondColor {
      id
      name
      color {
        hex
        cssRgb
      }
    }
  }
`;

/**
 * Polymorphic bgColor on SliderImageRecord only (BrandColor | ColorGradient union).
 * Do not use on fields typed as BrandColorRecord only (section / featured / video).
 */
export const sliderImageBgColorSelection = `
  __typename
  ${brandColorRecordFields}
  ${colorGradientRecordFields}
`;

/** Legacy bgColor fields that expose `color { hex }` directly (no union). */
export const legacyBgColorFields = `
  color {
    hex
    cssRgb
  }
`;

export const pageRelatedFragment = `
fragment pageRelatedFragment on PageRelatedRecord{
  __typename
    id
    useExternalUrl
    externalUrl
    buttonStyle
    useAnchor
    portfolioConfiguration {
      slug
      accoladesSlug
    }
    sectionAnchor {
    __typename
          ... on SectionQuoteRecord {
            id
            name

          }
          ... on SectionTextImageRecord {
            id
            title
      }
    }
    labelColor {
      name
      color {
        hex
      }
    }
    iconColor {
      name
      color {
        hex
        alpha
      }
    }
    icon {
      img {
        url
        width
        height
      }
    }
    addIcon
    linksToIframe
    iframeType
    linksToBuyButton
    productShopId
    buttonLabel {
      label
    }
    linksToProductAwardsPage
    linksToProductPage
    product {
      product{
        __typename
      slug
      id
      productTypeSpecific {
        __typename
        slug
      }
      }
      
    }
    page {
      __typename
      ... on BrandsPageRecord {
        id
        slug
        title
      }
      ... on BrandsProductRecord {
        __typename
        id
        slug
      }
      ... on ArticleRecord {
        id
        slug
      }
      ... on BrandsPortfolioRecord {
        id
        title
        slug
      }
      ... on PageRecord {
        id
        title
        slug
      }
    }
    typeColor {
      name
      color {
        hex
      }
    }

}
`;

/** Product card fields used in homepage products gallery and featured banner galleries. */
export const productConfShowcaseFields = `
  __typename
  id
  geolocationBuyButtonScope
  geo {
    countryAvailability
    listOfCountries
    countries {
      countryCode
    }
  }
  buttonGeo {
    countryAvailability
    listOfCountries
    countries {
      countryCode
    }
  }
  customLabel {
    label
  }
  customBrandLabel {
    label
  }
  previewColor {
    color {
      hex
      cssRgb
    }
  }
  addTitleUnderline
  underlineColor {
    color {
      hex
    }
  }
  customUnderlineAsset {
    img {
      url
      width
      height
    }
  }
  previewImage {
    responsiveImage {
      alt
      base64
      bgColor
      title
      width
      height
      sizes
      src
      srcSet
      webpSrcSet
      aspectRatio
    }
  }
  showBuyButton
  shopifyProductId
  productNameLabel
  specificSku
  showVintageYear
  showUmbrellaBrand
  showProductTypeSpecific
  showDesignationOfOrigin
  hideCallToAction
  showAccoladesCount
  product {
    __typename
    id
    slug
    productName
    _allReferencingBrandsProducts(first: "1") {
      id
      siteConfig {
        websiteName
      }
      accoladesRatings20 {
        ratingValue
      }
      accoladesRatings100 {
        ratingValue
      }
      accoladesRatingsYear
      awardsYear
    }
    _allReferencingRatings {
      ratingYear
      rating {
        ratingValue
      }
    }
    _allReferencingAwards {
      contestYear
      rating {
        ratingValue
      }
    }
    productTypeSpecific {
      __typename
      slug
      name
    }
    productBrand {
      title
      umbrellaBrand {
        id
        title
      }
    }
    vintageYear
    productRegion {
      name
    }
    productOrigin {
      originDesignation
    }
    factSheetImage {
      responsiveImage(imgixParams: { fit: max, h: 700, auto: format, q: 70 }) {
        ...responsiveImageFragment
      }
    }
    sku {
      __typename
      slug
      skuImageGallery {
        responsiveImage {
          ...responsiveImageFragment
        }
      }
    }
  }
`;
